document.addEventListener('DOMContentLoaded', function () {
  addCareerTextMediaVideoBtn()
})

function addCareerTextMediaVideoBtn () {
  const textAndMediaItems = document.querySelectorAll('.text-and-media__media')

  if (!textAndMediaItems || !textAndMediaItems.length) return

  textAndMediaItems.forEach(textAndMedia => {
    const thumbnail = textAndMedia.querySelector('.text-and-media__media img')
    const videoBtn = textAndMedia.querySelector('.text-and-media__media .btn--video')

    const internalVideo = textAndMedia.querySelector('.text-and-media__media video')
    const externalVideo = textAndMedia.querySelector('.text-and-media__media iframe')

    if (!videoBtn || !thumbnail) return

    videoBtn.addEventListener('click', function () {
      thumbnail.classList.add('hidden')
      videoBtn.style.display = 'none'
      if (internalVideo) {
        internalVideo.classList.remove('hidden')
      }
      if (externalVideo) {
        externalVideo.classList.remove('hidden')
      }
    })
  })
}
